import React from 'react'
import  './Skeleton.css'
const Shimmer = () => {
  return (
    <div className="shimmer-wrapper">
      <div className="shimmer"/>
    </div>
  )
}

export default Shimmer;